import FileUploadIcon from "@mui/icons-material/FileUpload";
import { Button } from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";
import { ReactElement, useContext } from "react";

import useText from "../../hooks/use-text";
import { UploadContext } from "../../providers/upload-provider";
import { LocalizedStrings, SupportedLanguages } from "../../utils/lang";

type Props = {
  onClick: () => void;
};

export default function TriggerButton(props: Props): ReactElement {
  const { onClick } = props;

  const { strings } = useText(local);
  const { isCreateAssetLoading } = useContext(UploadContext);

  return (
    <Button
      className="!border-none !bg-white shadow rounded-[15px] px-[30px] text-[15px] font-bold h-full uppercase"
      endIcon={<FileUploadIcon />}
      onClick={onClick}
      disabled={isCreateAssetLoading}
    >
      {strings.cta}
      {isCreateAssetLoading && (
        <LinearProgress className="absolute bottom-[10px] left-[20px] right-[20px]" />
      )}
    </Button>
  );
}

type LocalSchema = {
  cta: string;
};

const local: LocalizedStrings<LocalSchema, SupportedLanguages> = {
  default: {
    cta: "Upload",
  },
};
